import React, { useState } from 'react'
import injectSheet from 'react-jss'
import styles from './contributors.styles'
import Contributor from './contributor/contributor.container'
import Button from 'pobble-components/dist/button'
import AssessementInvitationModal from '../../../../../shared/assessment-invitation-modal/assessment-invitation-modal.container'
import { useSubscriptionPolicy } from 'pobble-components/dist/subscriptions'
import { SubsCrown } from 'pobble-components/dist/subscriptions'
import { UpsellModal } from '../../../../../upsell/upsell'

const Contributors = ({
  classes,
  pending,
  contributors,
  onOpenInvitationAssessmentDialog,
  id,
  closed,
  onOpenInviteesDialog,
  canSeeInvitees,
  inviteesCount
}) => {
  const invitationSP = useSubscriptionPolicy(
    sp => sp.moderation && sp.moderation.invite_people_to_assessment_file
  )
  const [upsellModalOpen, setUpsellModalOpen] = useState(false)

  return (
    <div className={classes.container}>
      <header className={classes.header}>
        <h2>Contributors</h2>
        <Button
          action={() =>
            invitationSP.restricted
              ? setUpsellModalOpen(true)
              : onOpenInvitationAssessmentDialog(id)
          }
          disabled={closed}
          className={classes.button}>
          {invitationSP.restricted && <SubsCrown accent />}Invite
        </Button>
        {canSeeInvitees && inviteesCount > 0 && (
          <Button
            action={() => onOpenInviteesDialog(id)}
            simple
            className={classes.sharedButton}>
            {inviteesCount}
          </Button>
        )}
      </header>
      {!pending &&
        contributors &&
        !!contributors.length &&
        contributors.map(contributor => (
          <Contributor key={contributor.id} id={contributor.id} />
        ))}
      {!pending && contributors && !contributors.length && (
        <span>No contributors yet.</span>
      )}
      <AssessementInvitationModal />
      <UpsellModal
        id="assesment-file"
        isOpen={upsellModalOpen}
        requestClose={() => setUpsellModalOpen(false)}
      />
    </div>
  )
}

export default injectSheet(styles)(Contributors)
